import * as React from 'react';

// COMPONENTS
import ReadActivity from './ReadActivity';
import UpdateActivity from './UpdateActivity';

// TYPES
import { FeedbackActionsAction } from '../../../api/models';
import { closeModalType } from '../../../components/GlobalModal';

export enum ViewTypes {
	Create = 'showCreate',
	Read = 'showRead'
}

const defaultViewTypes = {
	[ViewTypes.Create]: false,
	[ViewTypes.Read]: false
};

type ShowViewType = (type: string) => void;

interface FeedbackProgressModalTypes {
	viewType: ViewTypes;
	activity?: FeedbackActionsAction;
	closeModal?: closeModalType;
	refreshFeedbackProgress: (feedbackId: string | undefined) => Promise<void>;
	feedbackId?: string;
}

export interface FeedbackProgressViewTypes {
	activity?: FeedbackActionsAction;
	showView: ShowViewType;
	closeModal?: closeModalType;
	refreshFeedbackProgress: (feedbackId: string | undefined) => Promise<void>;
	feedbackId?: string;
}

const FeedbackProgressModal: React.FC<FeedbackProgressModalTypes> = ({
	viewType,
	activity,
	closeModal,
	refreshFeedbackProgress,
	feedbackId
}) => {
	const [state, setState] = React.useState({ ...defaultViewTypes, [viewType || ViewTypes.Read]: true });

	const showView: ShowViewType = (viewType) => {
		setState({ ...defaultViewTypes, [viewType]: true });
	};

	if (state.showCreate) {
		return (
			<UpdateActivity
				showView={showView}
				closeModal={closeModal}
				refreshFeedbackProgress={refreshFeedbackProgress}
				feedbackId={feedbackId}
			/>
		);
	} else if (state.showRead) {
		if (activity) {
			return (
				<ReadActivity
					activity={activity}
					showView={showView}
					closeModal={closeModal}
					refreshFeedbackProgress={refreshFeedbackProgress}
					feedbackId={feedbackId}
				/>
			);
		} else return null;
	} else {
		return null;
	}
};

export default FeedbackProgressModal;
